import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Navbar from './components/Navbar';
import Signin from './Common/Signin.jsx';  // Adjust path as needed
import Dashboard from "./pages/Dashboard/Dashboard.js";
import Rules from "./pages/Rules/rules.js";
import Announcement from "./pages/Announcements/announcement.js";
import Profile from "./pages/Profile/profile.js";
import Handbook from "./pages/Handbook/handbook.js";
import Payroll from "./pages/Payroll/payroll-report.js";
import Schedule from "./pages/Schedule/my-schedule.js";
import AddLeave from "./pages/Leave/add-leave.js";
import Salary from "./pages/Salary/salary.js";
import OverTime from "./pages/Overtime/overtime-report.js";
import WorkReports from "./pages/WorkReports/work-report.js";
import AddReport from "./pages/WorkReports/add-report.js";
import EditWorkReport from "./pages/WorkReports/edit-work-report.js";
import Settings from "./pages/AcoountSettings/account-settings.js";
import ResetPassword from "./pages/AcoountSettings/reset-password.js";
import TimeHistory from "./pages/TimeHistory/time-history.js";
import TimingsHistory from "./pages/TimeHistory/timings-history.js";
import ProvidentFund from "./pages/ProvidentFund/provident-fund.js";
import ProvidentFundHistory from "./pages/ProvidentFund/provident-fund-history.js";
import PendingLeave from "./pages/Leave/pending-leave.js";
import RejectedLeave from "./pages/Leave/rejected-leave.js";
import TotalLeave from "./pages/Leave/total-leave.js";
import ApplyLeave from "./pages/Leave/apply-leave.js";
import ApprovedLeave from "./pages/Leave/approved-leave.js";
import ProvidentFundReq from "./pages/ProvidentFund/provident-fund-req.js";
import PayinVoice from "./pages/Payroll/pay-invoice.js";
import Leaves from "./pages/Leave/Leaves.js";
import PasswordReset from "./pages/PasswordReset.js";
import ForgotPassword from "./pages/ForgotPassword.js";
import DeptAnnouncement from "./pages/DepartmentAnnouncements/departmentAnnouncements.js";
import EditLeave from "./pages/Leave/edit-leave.js";
import EmployeeHierarchy from "./pages/TeamChart.js";
import SessionManager from './components/SessionManager'; // adjust path
import LeaveManagement from "./pages/Leave/LeaveManagement.js";

// Protected Route Component
const ProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem('accessToken') && localStorage.getItem('refreshToken');
  return isAuthenticated ? element : <Navigate to="/" />;
};

// Prevent user from accessing sign-in page if already authenticated
const RedirectIfAuthenticated = ({ element }) => {
  const isAuthenticated = localStorage.getItem('accessToken') && localStorage.getItem('refreshToken');
  return !isAuthenticated ? element : <Navigate to="/dashboard" />;
};

// Main App Component
const App = () => {
  return (
    <BrowserRouter>
      <SessionManager />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<RedirectIfAuthenticated element={<Signin />} />} />
        <Route path="password-reset" element={<PasswordReset />} />
        <Route path="forgotpassword/:userId/:token" element={<ForgotPassword />} />

        {/* Protected Routes */}
        <Route path="/*" element={
          <ProtectedRoute element={
            <>
              <Sidebar />
              <div className="content-container">
                <Navbar />
                <Routes>
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="handbook" element={<Handbook />} />
                  <Route path="rules" element={<Rules />} />
                  <Route path="announcement" element={<Announcement />} />
                  <Route path="profile" element={<Profile />} />
                  <Route path="payroll-report" element={<Payroll />} />
                  <Route path="schedule" element={<Schedule />} />
                  <Route path="pending-leave" element={<PendingLeave />} />
                  <Route path="approved-leave" element={<ApprovedLeave />} />
                  <Route path="rejected-leave" element={<RejectedLeave />} />
                  <Route path="total-leave" element={<TotalLeave />} />
                  <Route path="apply-leave" element={<ApplyLeave />} />
                  <Route path="add-leave" element={<AddLeave />} />
                  <Route path="leaves" element={<Leaves />} />
                  <Route path="salary" element={<Salary />} />
                  <Route path="overtime-report" element={<OverTime />} />
                  <Route path="work-report" element={<WorkReports />} />
                  <Route path="add-report" element={<AddReport />} />
                  <Route path="/my-edit-report/:reportId" element={<EditWorkReport />} />
                  <Route path="account-settings" element={<Settings />} />
                  <Route path="reset-password" element={<ResetPassword />} />
                  <Route path="time-history" element={<TimeHistory />} />
                  <Route path="timings-history" element={<TimingsHistory />} />
                  <Route path="provident-fund" element={<ProvidentFund />} />
                  <Route path="provident-fund-history" element={<ProvidentFundHistory />} />
                  <Route path="provident-fund-req" element={<ProvidentFundReq />} />
                  <Route path="pay-invoice" element={<PayinVoice />} />
                  <Route path="department-announcement" element={<DeptAnnouncement />} />
                  <Route path="/edit-leave/:id" element={<EditLeave />} />
                  <Route path="/team-chart" element={<EmployeeHierarchy />} />
                  <Route path="/leave-management" element={<LeaveManagement />} />

                </Routes>
              </div>
            </>
          } />
        } />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
